export default __webpack_public_path__ + "928b58412733e661a6c27f449949163b.png";